import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  translationConstants,
  Directions,
  sportConstants,
  timezoneConstants,
  genderEnumReversed,
} from "../../../../../constants";
import GeneralTab from "../Tabs/GeneralTab";
import ParticipantsTab from "../Tabs/ParticipantsTab";
import PreviousParticipantsTab from "../Tabs/PreviousParticipantsTab";
import { competitionActions } from "../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  findConstantValue,
  formatDateTimeRangeFromServer,
  moveBack,
} from "../../../../../system";
import { useLocation } from "react-router-dom";
import ReviewStars from "../../../../../shared/components/ReviewStars/ReviewStars";
import { TimeIcon, ArrowLeftIcon } from "../../../../../assets/images/icon";

const ViewUpcomingCompetitions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const competitionId = location.state.id;
  const screen = location.state.screen;
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const [key, setKey] = useState("generalTab");
  const generalData = useSelector(
    (state) => state.CompetitionReducer.competitionGeneralDetail
  );
  const isUpcomingScreen = useSelector(
    (state) => state.CompetitionReducer.isUpcomingScreen
  );
  const totalPaymentData = useSelector(
    (state) => state.CompetitionReducer.competitionTotalPaymentById
  );

  const [classes, setBoatTypes] = useState("");
  useEffect(() => {
    if (generalData?.classes) {
      const names = generalData?.classes
        ?.map((data) => {
          const name =
            direction === Directions.rtl && data.arabicName
              ? data?.arabicName
              : data?.name;
          const genderText = t(
            translationConstants[genderEnumReversed[data?.gender]]
          );
          return `${name} - ${genderText}`;
        })
        .join(", ");

      setBoatTypes(names);
    }
    // eslint-disable-next-line
  }, [generalData, direction]);

  useEffect(() => {
    if (competitionId) {
      dispatch(
        competitionActions.getCompetitionGeneralDetailById(
          competitionId,
          screen
        )
      );
      dispatch(
        competitionActions.getCompetitionTotalPaymentById(competitionId)
      );
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="UserDiv">
      {generalData && Object.keys(generalData).length > 0 ? (
        <>
          <div>
            <div className="row">
              <div className={`col-12 col-sm-6`}>
                <p className="UserTabHeading general-title mt-0 text-break">
                  <span className="cursor-pointer px-2 ps-0" onClick={moveBack}>
                    <img
                      src={ArrowLeftIcon}
                      className="rotated-element"
                      alt="backArrowIcon"
                    />
                  </span>
                  {direction === Directions.rtl
                    ? generalData.arabicTitle || generalData.title
                    : generalData.title}
                </p>
                <p className="competition-detail-text text-black font-20 fw-bold">
                  {t(findConstantValue(generalData.sportId, sportConstants))}
                </p>
                <p className="competition-detail-text font-16">{classes}</p>
                <p className="competition-detail-text font-16">
                  {formatDateTimeRangeFromServer(
                    generalData.startDateString,
                    generalData.endDateString,
                    timezoneConstants.dayMonthYearFormat
                  )}
                </p>
                <p className="competition-detail-text font-16 d-flex gap-2">
                  <img alt="" name="activityDate" src={TimeIcon} />
                  {formatDateTimeRangeFromServer(
                    generalData.startDateString,
                    generalData.endDateString,
                    timezoneConstants.hourMinuteFormat
                  )}
                </p>
              </div>
              <div className="`col-12 col-sm-6 d-md-flex gap-5 justify-content-md-end">
                {!isUpcomingScreen && generalData.isScorePublished && (
                  <div>
                    <p className="cometition-detail-payment-heading">
                      {t(translationConstants.TOTAL_REVIEW_SCORE)}
                    </p>
                    <p className="cometition-detail-payment-text d-flex justify-content-end">
                      <ReviewStars value={generalData?.rating} size={10} />
                    </p>
                  </div>
                )}
                {generalData.isPublicRegistrationAllowed ? (
                  <div className={``}>
                    <p className="cometition-detail-payment-heading">
                      {t(translationConstants.TOTAL_PAYMENT)}
                    </p>
                    <p className="cometition-detail-payment-text">
                      {translationConstants.SAR}{" "}
                      {totalPaymentData?.totalPayment?.toFixed(2) || 0}
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="tabsDiv">
              <div>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className=""
                >
                  <Tab
                    eventKey="generalTab"
                    title={t(translationConstants.GENERAL_TAB)}
                  >
                    {key === "generalTab" && (
                      <GeneralTab
                        competitionId={competitionId}
                        screen={screen}
                      />
                    )}
                  </Tab>
                  {isUpcomingScreen ? (
                    <Tab
                      eventKey="participantsTab"
                      title={t(translationConstants.PARTICIPANTS_TAB)}
                    >
                      {key === "participantsTab" && (
                        <ParticipantsTab
                          id={generalData.id}
                          isPublicRegistrationAllowed={
                            generalData.isPublicRegistrationAllowed
                          }
                          refundPercentage={generalData.refundPercentAge}
                        />
                      )}
                    </Tab>
                  ) : (
                    <Tab
                      eventKey="PreviousParticipantsTab"
                      title={t(translationConstants.PARTICIPANTS_TAB)}
                    >
                      {key === "PreviousParticipantsTab" && (
                        <PreviousParticipantsTab
                          id={generalData.id}
                          isPublicRegistrationAllowed={
                            generalData.isPublicRegistrationAllowed
                          }
                          refundPercentage={generalData.refundPercentage}
                          isScorePublished={generalData?.isScorePublished}
                          isScoreUpdated={generalData?.isScoreUpdated}
                        />
                      )}
                    </Tab>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default ViewUpcomingCompetitions;
